import { useTranslation } from "react-i18next";

import { IconFile05, IconLayersThree01 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";

const {
  HRM: { POSITIONS },
} = ROUTES;
type ExtraPositionInformationsPageHeaderProps = {
  downloadReport: (fileName: string) => void;
  isLoading: boolean;
};

export const ExtraPositionInformationsPageHeader = ({
  downloadReport,
  isLoading,
}: ExtraPositionInformationsPageHeaderProps) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconLayersThree01 fill="dark" size="20" />,
    },
    {
      label: t("EXTRA_POSITION_INFORMATIONS.BREADCRUMBS.FIRST_STEP"),
      link: POSITIONS,
    },
    {
      label: t("EXTRA_POSITION_INFORMATIONS.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  const actions = [
    <Button
      fill="fill"
      size="sm"
      type="primary"
      htmlType="button"
      onClick={() => {
        downloadReport("positions_tree_report");
      }}
      loading={isLoading}
    >
      <IconFile05 size="20" fill="white" />
      {t("POSITION_LIST_TREE.DOWNLOAD_BUTTON")}
    </Button>,
  ];

  const headerText = {
    header: t("EXTRA_POSITION_INFORMATIONS.LABEL"),
    subHeader: t("EXTRA_POSITION_INFORMATIONS.DESCRIPTION"),
  };

  return (
    <Header
      breadcrumbs={breadcrumbs}
      headerText={headerText}
      actions={actions}
    />
  );
};
